import { css, useTheme } from '@emotion/react'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Button } from '../base-ui'
import { useTranslation } from 'next-i18next'

export default function CommentForm({ id }) {
    const { t } = useTranslation(['common', 'validation'])
    const theme = useTheme()
    const formStyle = css`
        height: 100%;
        .form-body {
            display: grid;
            align-content: center;
            height: 100%;
            gap: 5px;
        }
        .form-control {
            font-size: ${theme.fontSize.sm};
            width: 100%;
            label {
                display: block;
                margin-bottom: 0.5rem;
            }
            input,
            select,
            textarea {
                display: block;
                width: 100%;
                border-radius: ${theme.borderRadius.default};
                border: 1px solid ${theme.colors.lightGray};
                padding: 0.375rem 0.75rem;
                line-height: 1.5;
                background-clip: padding-box;
                &:focus {
                    color: ${theme.colors.secGray};
                    background-color: ${theme.colors.white};
                    border-color: ${theme.colors.lighter};
                    outline: 0;
                    box-shadow: 0 0 0 0.2rem rgb(7 176 195 / 10%);
                }
            }
            select {
                background-position: left 0.5rem center;
            }
        }
    `
    const [success, setSuccess] = useState(false)
    const {
        register,
        handleSubmit,
        resetField,
        formState: { errors }
    } = useForm({ mode: 'onChange', defaultValues: { news_id: id } })

    async function onSubmit(data) {
        try {
            const response = await fetch('/api/comment', {
                method: 'POST',
                body: JSON.stringify(data),
                headers: { contentType: null }
            })
            let responseObject = await response.json()
            if (response.status === 200) {
                setSuccess(responseObject.message)
                resetField('content')
            } else if (response.status === 400) {
                setSuccess(responseObject.message)
            }
        } catch (error) {
            console.error('An unexpected error happened occurred:', error)
        }
    }
    return (
        <form onSubmit={handleSubmit(onSubmit)} css={formStyle}>
            <div className="form-body lg:grid-cols-2 px-4 justify-items-center">
                <div className="form-control mt-2">
                    <label>
                        {t('نام', { ns: 'common' })}
                        <span style={{ color: 'red' }}>
                            {errors?.username?.message}
                        </span>
                    </label>
                    <input type="text" {...register('username')} />
                    <input type="hidden" {...register('news_id')} />
                </div>
                <div className="form-control mt-2">
                    <label>
                        {t('ایمیل', { ns: 'common' })}
                        <span style={{ color: 'red' }}>
                            {errors?.contact?.message}
                        </span>
                    </label>
                    <input type="email" {...register('contact')} />
                </div>
                <div className="form-control lg:col-span-2 mt-2">
                    <label>
                        {t('دیدگاه', { ns: 'common' })}*
                        <span style={{ color: 'red' }}>
                            {errors?.content?.message}
                        </span>
                    </label>
                    <textarea
                        type="textarea"
                        rows="5"
                        {...register('content', {
                            required: t('دیدگاه خود را وارد کنید', {
                                ns: 'validation'
                            }),
                            maxLength: 1000
                        })}
                    />
                </div>
                {success === false && (
                    <Button
                        type="submit"
                        backgroundColor="primary"
                        color="lighterGray"
                        className="mt-5 w-40 justify-center lg:col-span-2"
                    >
                        {t('ارسال', { ns: 'common' })}
                    </Button>
                )}
                {success && (
                    <Button
                        onClick={(e) => e.preventDefault()}
                        backgroundColor="primary"
                        color="lighterGray"
                        className="mt-5 w-40 justify-center lg:col-span-2"
                    >
                        {success}
                    </Button>
                )}
            </div>
        </form>
    )
}
